import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';

import ChangePinDialog from 'src/layouts/dashboard/common/change-pin-dialog';

import { fetchPasswordStatus } from './passwordStatus';

const OPEN = new Set(['/login', '/forgotPassword', '/resetPassword']);

export default function PinRequiredGate() {
  const [{ session }] = useCookies(['session']);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const decided = useRef('');

  useEffect(() => {
    if (!session) {
      decided.current = '';
      setOpen(false);
      return undefined;
    }
    if (OPEN.has(pathname) || decided.current === session) return undefined;
    let cancelled = false;
    fetchPasswordStatus(session)
      .then((result) => {
        if (cancelled || result?.status !== 'success') return;
        decided.current = session;
        setOpen(result.pinRequired === true);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [session, pathname]);

  return (
    <ChangePinDialog
      open={open}
      required
      sessionToken={session}
      onClose={() => {
        decided.current = session || '';
        setOpen(false);
      }}
    />
  );
}
